import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ListPickupComponent } from 'src/app/components/operation/pickup/list/listpickup.component';
import { AddPickupComponent } from 'src/app/components/operation/pickup/add/addpickup.component';
import { EditPickupComponent } from 'src/app/components/operation/pickup/edit/editpickup.component';
import { ListManifestComponent } from 'src/app/components/operation/manifest/list/listmanifest.component';
import { AddManifestComponent } from 'src/app/components/operation/manifest/add/addmanifest.component';
import { ManifestInboundComponent } from 'src/app/components/operation/manifest-inbound/manifestinbound.component';
import { DRSComponent } from 'src/app/components/operation/drs-scan/add/drs.component';
import { ListDRSComponent } from 'src/app/components/operation/drs-scan/list/list.component';
import { Page404Component } from 'src/app/components/page404/page404.component';
import { RateUploadComponent } from 'src/app/components/operation/rate-management/upload/rateupload.component';
import { RateCompareComponent } from 'src/app/components/operation/rate-management/compare/ratecompare.component';
import { BaggingComponent } from 'src/app/components/operation/manifest/bagging/bagging.component';
//import { InvoiceComponent } from 'src/app/components/invoices/invoice.component';

const routes: Routes = [
  { path: 'pickups', component: ListPickupComponent },
  { path: 'pickups/add', component: AddPickupComponent },
  { path: 'pickups/edit/:id', component: EditPickupComponent },

  { path: 'awb', loadChildren: () => import('./awb/awb.module').then(a => a.AwbModule) },

  { path: 'manifests', component: ListManifestComponent },
  { path: 'manifests/add', component: AddManifestComponent },
  { path: 'manifests/edit/:id', component: AddManifestComponent },
  { path: 'manifests/:id/inbound', component: ManifestInboundComponent },
  { path: 'manifests/bagging', component: BaggingComponent },

  { path: 'drs', component: ListDRSComponent },
  { path: 'drs/add', component: DRSComponent },
  { path: 'drs/edit/:id', component: DRSComponent },

  { path: 'rates/upload', component: RateUploadComponent },
  { path: 'rates/compare', component: RateCompareComponent },
  { path: '', component: Page404Component },
  //{ path: 'invoices', component: InvoiceComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperationRoutingModule { }

